import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

export const personsSlice = createSlice({
  name: 'persons',
  initialState: initialState,
  reducers: {
    clearPersons: () => {
      return initialState;
    },

    addPerson: (state, action) => {
      const instance = action.payload;
      const copiedState = { ...state };
      copiedState[instance.personId] = instance;
      return copiedState;
    },

    addPersons: (state, action) => {
      const copiedState = { ...state };
      action.payload.forEach((instance) => (copiedState[instance.personId] = instance));
      return copiedState;
    },

    updatePerson: (state, action) => {
      const instance = action.payload;
      const copiedState = { ...state };
      copiedState[instance.personId] = instance;
      return copiedState;
    },

    removePerson: (state, action) => {
      const personId = action.payload;
      const copiedState = { ...state };
      delete copiedState[personId];
      return copiedState;
    },

    maybeUpdatePersonLatestOutreachInfo: (state, action) => {
      const { personId, date, description } = action.payload;
      const currentInstance = state[personId];
      if (currentInstance && date > currentInstance.latestContactDate) {
        const modifiedInstance = {
          ...currentInstance,
          latestContactDate: date,
          latestContactDescription: description,
        };
        const copiedState = { ...state };
        copiedState[personId] = modifiedInstance;
        return copiedState;
      } else {
        return state;
      }
    },

    bulkChangeClientOwnerships: (state, action) => {
      const { oldOwnerId, newOwnerId } = action.payload;
      const copiedState = { ...state };
      for (const key in copiedState) {
        if (copiedState.hasOwnProperty(key)) {
          const person = copiedState[key];
          if (person.ownerId === oldOwnerId) {
            copiedState[key] = { ...person, ownerId: newOwnerId };
          }
        }
      }
      return copiedState;
    },
  },
});

export const {
  clearPersons,
  addPerson,
  addPersons,
  updatePerson,
  removePerson,
  maybeUpdatePersonLatestOutreachInfo,
  bulkChangeClientOwnerships,
} = personsSlice.actions;

export default personsSlice.reducer;
